
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"horanetProduitsVente"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeTerminal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeProduits"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horanetProduitsVente"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codeTerminal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeTerminal"}}},{"kind":"Argument","name":{"kind":"Name","value":"codeProduits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeProduits"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horanetProductCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"horanetProductTariff"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tariffCode"},"name":{"kind":"Name","value":"horanetTariffCode"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"tariffName"},"name":{"kind":"Name","value":"horanetTariffName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"horanetTariffCategoryCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"horanetProductPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"horanetProductTva"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":352}};
    doc.loc.source = {"body":"query horanetProduitsVente(\n\t$codeTerminal: String!\n\t$codeProduits: [String]\n) {\n\thoranetProduitsVente(\n\tcodeTerminal: $codeTerminal\n\tcodeProduits: $codeProduits\n\t) {\n\thoranetProductCode\n\thoranetProductTariff {\n\t\ttariffCode: horanetTariffCode\n\t\ttariffName: horanetTariffName\n\t\thoranetTariffCategoryCode\n\t}\n\thoranetProductPrice\n\thoranetProductTva\n\t\n\t}\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["horanetProduitsVente"] = oneQuery(doc, "horanetProduitsVente");
        
